module.exports = __webpack_public_path__ + "static/media/target-frame.f83b30dc.png";